/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Documents_Error_Server_Upload_MissingInputs */

const es_co2_projects_documents_error_server_upload_missing = /** @type {(inputs: Projects_Documents_Error_Server_Upload_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La subida no se completó. Vuelve a adjuntar el archivo.`)
};

/**

* @param {Projects_Documents_Error_Server_Upload_MissingInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const projects_documents_error_server_upload_missing = /** @type {((inputs?: Projects_Documents_Error_Server_Upload_MissingInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Documents_Error_Server_Upload_MissingInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_projects_documents_error_server_upload_missing(inputs)
});